// SPDX-License-Identifier: GPL-3.0-or-later
// The published modes of the SigmaBots table (THEME.md section 6).
// The how-to-play card lists every mode. No import of three or DOM.

import type { ModeInfo } from "../shared/contracts.ts";
import { MODE_ID } from "./ids.ts";

/** Every mode, in the order of the mode list. The order is the default pick at the saucer. */
export const MODES: readonly ModeInfo[] = [
  {
    id: MODE_ID.acceptAll,
    label: "ACCEPT ALL",
    description:
      "Select it at the saucer: orbits and ramps score 2x for 30 s, and a DENY target pays 5,000 for each second left.",
  },
  {
    id: MODE_ID.worksOnMyMachine,
    label: "BOT ORBIT RUN",
    description:
      "Select it at the saucer and make 3 orbits in 40 s for 15,000 each, then 50,000 and 5,000 for each earlier left orbit.",
  },
  {
    id: MODE_ID.contextWindowFull,
    label: "CONTEXT WINDOW FULL",
    description:
      "Select it at the saucer and drop the 3 TOKENS targets in 45 s (each pop bumper hit adds 1 s to the bar) for 10,000 each and 75,000.",
  },
  {
    id: MODE_ID.yoloFridayDeploy,
    label: "BOT FRIDAY DEPLOY",
    description:
      "Select it at the saucer and score 100,000 in 40 s with the ball saver on, while the spinner and both ramps score 2x, for 50,000.",
  },
  {
    id: MODE_ID.agentSwarm,
    label: "SIGMABOT SWARM",
    description:
      "Shoot the Ghost Ramp 3 times to light LOCK, lock 2 times at the saucer, then collect 50,000 jackpots in 3-ball multiball.",
  },
  {
    id: MODE_ID.askMode,
    label: "ASK MODE: PROD BOT",
    description:
      "Complete modes 1 to 4 and play SigmaBot Swarm, shoot the lit saucer, then DENY 8 shots in 90 s for 40,000 each and 500,000 at the end.",
  },
];

/** Label of a mode id. Unknown id: the id itself. */
export function modeLabel(id: string): string {
  return MODES.find((m) => m.id === id)?.label ?? id;
}
